import { render, staticRenderFns } from "./EditarGrupoModal.vue?vue&type=template&id=44640c90&scoped=true"
import script from "./EditarGrupoModal.vue?vue&type=script&lang=js"
export * from "./EditarGrupoModal.vue?vue&type=script&lang=js"
import style0 from "./EditarGrupoModal.vue?vue&type=style&index=0&id=44640c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44640c90",
  null
  
)

export default component.exports